import { Lock, LockOpen, LockPerson } from '@mui/icons-material'
import { ButtonBase, Card, CardContent, Divider, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'

const ExpedienteCard = ({ data: expediente, onClick }) => {
  return (
    <ButtonBase sx={{ width: '100%' }}>
      <Card
        sx={{ ':hover': { cursor: 'pointer' }, height: '100%', width: '100%' }}
        onClick={onClick}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
            }}
          >
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}
            >
              <Typography variant="h6">{expediente.numero_expediente}</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {expediente.fecha_alta}
              </Typography>

              {expediente?.status === '0300' ? (
                <Tooltip title="Abierto">
                  <LockOpen color="success" />
                </Tooltip>
              ) : expediente?.status === '0500' ? (
                <Tooltip title="En espera a que finalicen expedientes hijos" color="warning">
                  <LockPerson />
                </Tooltip>
              ) : (
                expediente?.status === '1000' && (
                  <Tooltip title="Cerrado">
                    <Lock color="error" />
                  </Tooltip>
                )
              )}
            </Box>
            <Divider sx={{ mb: 1 }} />
            {expediente?.descripcion_expediente && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">{expediente.descripcion_expediente}</Typography>
              </Box>
            )}
            <Box sx={{ display: 'block', textAlign: 'left', mb: 1, ml: 1 }}>
              {expediente?.campos.map((campo) => (
                <Typography key={campo.columna} sx={{ mb: 0.5 }}>
                  {campo.literal}: {campo.d_valor ?? campo.valor}
                </Typography>
              ))}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </ButtonBase>
  )
}

export default ExpedienteCard
